<div class="c__contact-list">
  @if (reinsurancesData) {
    <ul sd-list-inline>
      @for (info of reinsurancesData; track info) {
        <li>
          @if (info.link?.url) {
            <div>
              @if (info.iconName) {
                <sd-link
                  customClass="is-full-area c__nav-link"
                  [icon]="info.iconName"
                  [size]="iconSizeEnum.small"
                  role="button"
                  [titleHidden]="false"
                  [link]="info.link"
                >
                  <span class="c__icon-label is-caption">
                    {{info.label}}
                  </span>
                </sd-link>
              }
            </div>
          } @else {
            <p class="is-caption is-regular">
              @if (info.iconName) {
                <sd-icon [name]="info.iconName" [size]="iconSizeEnum.small" />
              }
              {{info.label}}
            </p>
          }
          @if (info.tooltipText) {
            <sd-tooltip [position]="positionEnum.bottom">
              <sd-icon name="icon-help" [size]="iconSizeEnum.xs" />
              <ng-container sd-tooltip-template>
                <sd-html innerClass="is-wysiwyg" [html]="info.tooltipText" tag="div" />
              </ng-container>
            </sd-tooltip>
          }
        </li>
      }
    </ul>
  }
</div>
